
import { supabase } from '@/integrations/supabase/client';
import { formatPhoneToE164 } from '@/utils/supabase/auth/phoneUtils';

// Переэкспортируем formatPhoneToE164
export { formatPhoneToE164 };

/**
 * Получение текущего пользователя из auth
 */
export const getCurrentUser = async () => {
  try {
    const { data, error } = await supabase.auth.getUser();
    
    if (error) {
      console.error('Ошибка при получении данных текущего пользователя:', error);
      return { data: null, error };
    }
    
    return { data: data.user, error: null };
  } catch (error) {
    console.error('Неожиданная ошибка при получении текущего пользователя:', error);
    return { data: null, error };
  }
};

/**
 * Проверка подключения к Supabase
 */
export const checkSupabaseConnection = async () => {
  try {
    // Простой запрос для проверки соединения
    const { data, error } = await supabase.from('couriers').select('id').limit(1);
    
    if (error) {
      console.error('Ошибка подключения к Supabase:', error);
      return { connected: false, error };
    }
    
    return { connected: true, data };
  } catch (error) {
    console.error('Неожиданная ошибка при проверке подключения:', error);
    return { connected: false, error };
  }
};
